import { useAppSettings } from 'selectors/appSettingsSelectors';
import { useIsAuthReady } from './useAuth';

/**
 * Hook to determine if app settings are ready for components to use.
 * Returns true when:
 * - Settings have been initialized (initial settings fetch is complete)
 *
 * Use this hook in components that need to wait for settings state
 * to be fully resolved before running effects or making settings-dependent decisions.
 */
export function useSettingsReady(): boolean {
  const { isSettingsInitialized } = useAppSettings();
  return isSettingsInitialized;
}

/**
 * Hook to determine if both authentication and settings are ready.
 * Returns true when both auth and settings initialization are complete.
 *
 * Use this for components that depend on both user and settings data.
 */
export function useAppReady(): boolean {
  const authReady = useIsAuthReady();
  const settingsReady = useSettingsReady();
  return authReady && settingsReady;
}
